import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router";
import { Icon } from "../../../../../components/Icon";
import LineProgressBar from "../../../../../components/LineProgressBar/LineProgressBar";
import { getMotivation } from "../../../../../redux/actions/statistic";


const MotivationBlock=()=>{
    const [ready,setReady]=useState(false);
    const [weekProgress,setWeekProgress]=useState(0);
    const [weekByDayProgress,setWeekByDayProgress]=useState([]);
    const [dayProgress,setDayProgress]=useState(0);
    const [week2Offset,setWeek2Offset]=useState(0);
    const [week1Offset,setWeek1Offset]=useState(0);
    const dispatch=useDispatch();
    const daysOfWeek = ["пн", "вт", "ср", "чт", "пт", "сб", "нд"];


    useEffect(() => {
        if(!ready){
            initFunc();
        }

    }, []);


    const initFunc =()=>{

        dispatch(getMotivation()).then(res=>{

            setWeekProgress(res.weekProgress);
            setWeekByDayProgress(res.weeksForDay);
            console.log(res);
            setDayProgress(res.weeksForDay[res.weeksForDay.length-1].progress);
            const heightPath1 = 100;
            const heightPath2 = 118;
            const startPath1 = 24;
            const startPath2 = 0;
            let totalPixels = 1.32 * res.weekProgress;
            setWeek2Offset(calculateweek2Offset(totalPixels, startPath2, heightPath2));
            setWeek1Offset(calculateOffset(totalPixels, startPath1, heightPath1));
            setReady(true);
        }).catch(e=>{

        })
       
    }
    const clickAsk = () => {
        const url = "https://ap.sportforall.gov.ua/info/0TLL23tE"; // Replace with your URL
        window.open(url, "_blank");
    };


    const calculateOffset = (progress, start, height) => {
        const progressInProcent = ((progress-32) * 100) / height;
        return progressInProcent;
      };
      const calculateweek2Offset = (progress, start, height) => {
        const progressInProcent = (progress * 100) / height;
        return progressInProcent;
      };
 
      const clickMotivationDay=(progress)=>{
        if(progress === undefined){
            return;
        }else{
            setDayProgress(progress>=100?100:progress);
        }
      }


    return(
        <div className="motivationBlock">
        <div className="motivationBlockLeft">
            <div>
            <svg width="80" height="132" viewBox="0 0 80 132" fill="none" xmlns="http://www.w3.org/2000/svg">
           {ready&& <defs>
                <linearGradient id="progressGradient" x1="0%" y1="100%" x2="0%" y2="0%">
                    <stop offset="0%" stop-color="#ffcc00" />
                    <stop offset={week1Offset+'%'} stop-color="#0066cc" className="stop1"/>
                    <stop offset={week1Offset+'%'} stop-color="rgba(0,0,0,0)" />
                    <stop offset="100%" stop-color="rgba(0,0,0,0)" />
                </linearGradient>
                <linearGradient id="progressGradient2" x1="0%" y1="100%" x2="0%" y2="0%">
                    <stop offset="0%" stop-color="#ffcc00" />
                    <stop offset={week2Offset+'%'} stop-color="#0066cc" className="stop1"/>
                    <stop offset={week2Offset+'%'} stop-color="rgba(0,0,0,0)" />
                    <stop offset="100%" stop-color="rgba(0,0,0,0)" />
                </linearGradient>
            </defs>}
            <path d="M21.4033 99.4712C21.4033 99.6231 21.4084 99.7738 21.4106 99.9251H28.4923C28.4867 99.7361 28.4824 99.5464 28.4802 99.3569C28.4775 99.2007 28.4754 99.0446 28.4751 98.8888C28.4697 96.533 29.0108 94.2446 29.0753 93.3528C30.9344 79.754 39.7995 73.9338 39.9884 73.8113C40.5999 74.3405 49.2808 81.4005 50.9322 93.5334C50.9945 94.4238 51.4939 96.7319 51.5232 99.0893C51.5275 99.2457 51.5294 99.4023 51.5289 99.5593C51.5283 99.6812 51.5267 99.8031 51.5246 99.9251H58.5899C58.5926 99.7738 58.5972 99.6233 58.5972 99.4712C58.5972 87.51 53.5251 79.0213 48.6788 73.6385C44.5358 64.892 43.9276 55.107 44.3541 45.3949C44.7621 36.1124 45.0669 24.1345 45.4161 14.8499C45.6066 9.7772 44.3923 5.08132 40.9598 0.984879C40.7517 0.736708 40.1029 0.113857 39.9252 0C39.9252 0 39.0998 0.745857 38.8923 0.993221C35.4598 5.08993 34.2457 9.78554 34.4363 14.858C34.7852 24.1423 35.0902 36.1203 35.4982 45.403C35.9226 55.068 35.4748 64.9622 31.2099 73.582C26.398 78.9026 21.4033 87.3448 21.4033 99.4712Z"
                    fill="url(#progressGradient)"/>
            <path d="M79.9992 13.2386C79.7952 13.2682 79.6538 13.2585 79.5409 13.311C79.217 13.4612 78.8934 13.6181 78.5894 13.8043C74.4291 16.3558 70.8315 19.5459 67.7975 23.3724C61.7089 31.0517 58.7425 39.8774 57.9732 49.583C57.5639 54.754 56.8126 59.8975 56.2337 65.0552C55.941 67.6627 55.6897 70.2744 55.4172 72.9057C57.9732 72.4842 59.9576 73.422 61.6584 74.9719C63.9866 77.0937 64.3725 80.5296 62.3806 82.9753C61.4695 84.0939 60.0896 84.8901 58.7986 85.6416C58.7502 85.6696 58.7029 85.6963 58.6562 85.7216C59.3733 87.7374 59.9571 89.9117 60.3559 92.2478C60.5072 92.1923 60.6696 92.1331 60.7626 92.1005C66.1666 90.2021 69.4951 86.5175 70.3103 80.7686C71.0043 75.8736 68.313 70.6843 63.735 68.0556C62.9536 67.6069 62.7058 67.1865 62.8166 66.2856C63.5194 60.5556 64.2653 54.8275 64.7843 49.0791C65.2651 43.7553 66.7506 38.8328 69.0723 33.9926C70.1552 31.7346 73.2317 27.2347 73.2317 27.2347C73.2317 27.2347 73.2317 77.593 73.2317 102.639H46.0718V108.708H50.6227C49.2581 115.249 45.9517 119.625 43.384 122.162V101.526C43.7678 99.9136 44.9816 97.7557 48.6026 96.6707C48.7851 96.6161 48.9671 96.5528 49.1496 96.4893C49.0316 95.523 48.902 94.7306 48.8749 94.3042C48.6994 92.8849 48.4411 91.5603 48.1258 90.3216C47.496 90.5216 46.9738 90.6936 46.601 90.8287C44.3196 91.6545 40.7713 94.6407 40.0112 95.256C39.2513 94.6407 35.7029 91.6545 33.4216 90.8287C33.0488 90.6936 32.5263 90.5216 31.8968 90.3216C31.5818 91.5603 31.3232 92.8846 31.1477 94.3042C31.1203 94.7306 30.991 95.523 30.873 96.4893C31.0552 96.5528 31.2375 96.6161 31.42 96.6707C34.9729 97.7355 36.2082 99.8334 36.6162 101.436V122.084C34.062 119.507 30.773 115.116 29.3934 108.708H33.9731V102.639H6.76752V27.2344C6.76752 27.2344 9.84367 31.7346 10.9268 33.9924C13.2485 38.8322 14.7341 43.755 15.2149 49.0789C15.7342 54.8269 16.4798 60.5553 17.1826 66.2853C17.2934 67.1865 17.0455 67.6067 16.2642 68.0554C11.6861 70.6843 8.99487 75.8736 9.68885 80.7684C10.5041 86.517 13.8326 90.2018 19.2366 92.1003C19.3253 92.1315 19.4772 92.1867 19.6228 92.2402C20.011 89.8888 20.5808 87.7061 21.2828 85.6876C21.2554 85.6723 21.2285 85.6575 21.2006 85.6413C19.9096 84.8898 18.5295 84.0937 17.6186 82.975C15.6267 80.5294 16.0124 77.0932 18.3408 74.9716C20.0416 73.4217 22.026 72.484 24.582 72.9055C24.3095 70.2741 24.0582 67.6624 23.7655 65.055C23.1868 59.8972 22.4356 54.7537 22.026 49.5827C21.257 39.8771 18.2905 31.0515 12.2016 23.3721C9.1677 19.5457 5.57012 16.3558 1.40973 13.8041C1.10575 13.6178 0.78214 13.4609 0.458264 13.3107C0.345378 13.2585 0.204001 13.2682 0 13.2383V108.709H22.1144C25.5144 124.766 39.9996 132 39.9996 132C39.9996 132 54.5587 125.084 57.9111 108.709H80L79.9992 13.2386Z"
                    fill="url(#progressGradient2)"/>
            </svg>

            </div>
            <div className="leftSideText">
                {weekProgress >= 100 ?<>Тижнева мета досягнута!</> :<>Ще <span>{(100-weekProgress)}%</span> і тижнева мета буде досягнута</>}
            </div>

        </div>
        <div className="motivationBlockSeparator">

        </div>
        <div className="motivationBlockRight">
            <h3>Фізична активність</h3>
            <div>
                <div className="motivationBlockLine">
                    <div className="motivationBlockText">
                        <div>
                            Тижнева норма за ВООЗ: <span>{weekProgress>=100?100:weekProgress}%</span>
                        </div>
                        <div className="askButton" onClick={clickAsk}>
                            ?
                        </div>
                    </div>
                    <LineProgressBar color={'blue'} value={weekProgress} max={100}></LineProgressBar>
                </div>
                <div>
                <div className="motivationBlockText">
                    <div>
                        Денна норма за ВООЗ: <span>{dayProgress}%</span>
                    </div>
                    <div className="askButton" onClick={clickAsk}>
                        ?
                    </div>
                    </div>
                    <LineProgressBar  value={dayProgress} max={100}></LineProgressBar>

                </div>
                <div className="motivationBlockWeek">
                    <div className="motivationBlockWeekText">
                        Результативність по днях:
                    </div>
                    <div className="motivationBlockWeekBlock">
                        {daysOfWeek.map((day, index) => {
                            const progress = weekByDayProgress[index]?.progress;

                            return (
                            <div
                                onClick={()=>clickMotivationDay(progress)}
                                key={index}
                                className={
                                progress === undefined
                                    ? "motivationBlockWeekDay"
                                    : progress === 0
                                    ? "motivationBlockWeekDay dayNone"
                                    : progress < 100
                                    ? "motivationBlockWeekDay dayParticical"
                                    : "motivationBlockWeekDay dayFull"
                                }
                            >
                                {day}
                            </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}
export default MotivationBlock;